/**
 * Kwolly — Contact form Web Component
 * Handles submit loading state to prevent double-submission.
 * Re-initialises on Theme Editor section:load.
 */
class KwollyContactForm extends HTMLElement {
  connectedCallback() {
    this._bindSubmit();
    document.addEventListener('shopify:section:load', () => this._bindSubmit());
  }

  _bindSubmit() {
    const form   = this.querySelector('.kwolly-contact__form');
    const button = this.querySelector('.kwolly-contact__submit');

    if (!form || !button) return;

    // Guard against duplicate listeners on re-init
    if (form._kwollyBound) return;
    form._kwollyBound = true;

    form.addEventListener('submit', () => {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('disabled', 'disabled');
    });
  }
}

if (!customElements.get('kwolly-contact-form')) {
  customElements.define('kwolly-contact-form', KwollyContactForm);
}
